module.exports = __webpack_public_path__ + "fromBrideToParents-jp-w.45eaf264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-jp-w.jpg
// module id = AMEc
// module chunks = 0